// Compact toolbar Select — promoted from analyse's shared.tsx on its second
// consumer (gradebook). Static options, non-clearable; disabled options may
// carry an inline muted hint (Radix disabled items don't receive hover).
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/cn';

export interface InlineSelectOption {
  value: string;
  label: string;
  disabled?: boolean;
  /** Muted hint rendered under a disabled option (v3 tooltip-on-disabled parity). */
  hint?: string;
}

export const InlineSelect = ({
  value,
  onChange,
  options,
  ariaLabel,
  disabled,
  testId,
  triggerClassName,
}: {
  value: string;
  onChange: (next: string) => void;
  options: InlineSelectOption[];
  ariaLabel: string;
  disabled?: boolean;
  testId?: string;
  triggerClassName?: string;
}) => (
  <Select value={value} onValueChange={onChange} disabled={disabled}>
    <SelectTrigger
      aria-label={ariaLabel}
      data-testid={testId}
      className={cn('w-50 bg-card', triggerClassName)}
    >
      <SelectValue />
    </SelectTrigger>
    <SelectContent position="popper">
      {options.map((opt) => (
        <SelectItem key={opt.value} value={opt.value} disabled={opt.disabled}>
          <span className="flex flex-col items-start">
            <span>{opt.label}</span>
            {opt.disabled && opt.hint ? (
              <span className="text-xs text-muted-foreground">{opt.hint}</span>
            ) : null}
          </span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
